<script setup lang="ts">
import EmblaCarousel from '@/shared/ui/EmblaCarousel/index';
import LawyerCard from '@/widgets/LawyerCard/index';
import { useTopSpecialists } from '@/pages/main/composables/useTopSpecialists';

const isMobile: boolean = useIsMobile();
const { lawyers, dotsCount } = useTopSpecialists();

const slider = ref<{ $el: HTMLElement } | null>(null);
let observer: IntersectionObserver | null = null;

const observeSlides = (): void => {
  observer?.disconnect();
  observer = null;

  const sliderEl = slider.value?.$el;
  const root = sliderEl?.querySelector('.embla__viewport');
  if (!sliderEl || !root) return;

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('_active', entry.isIntersecting);
      });
    },
    {
      root,
      rootMargin: isMobile ? '0px -100px 0px -100px' : '0px -200px 0px -200px',
    },
  );

  sliderEl
    .querySelectorAll('.top-specialists-section__slide')
    .forEach((el) => observer?.observe(el));
};

watch([slider, lawyers], observeSlides, { flush: 'post' });

onBeforeUnmount(() => observer?.disconnect());
</script>

<template>
  <section
    v-if="lawyers.length"
    :class="['top-specialists-section', { _mobile: isMobile }]"
  >
    <h2 class="top-specialists-section__title">ТОП Специалистов</h2>

    <EmblaCarousel
      ref="slider"
      class="top-specialists-section__slider"
      :dots-count="dotsCount"
      :options="{
        loop: true,
        slidesToScroll: isMobile ? 1 : 2,
        align: 'start',
      }"
    >
      <div
        v-for="lawyer in lawyers"
        :key="lawyer.id"
        class="top-specialists-section__slide"
      >
        <LawyerCard :data="lawyer" is-card-slider is-push-to-feedbacks />
      </div>
    </EmblaCarousel>
  </section>
</template>

<style lang="less">
.top-specialists-section {
  .container-d();

  padding-bottom: 150px;

  &__title {
    .title-section();
  }

  &__slider .embla__container {
    padding: 60px 0 45px;
  }

  &__slide .lawyer-card._slider {
    align-content: start;
  }

  &__slide:not(._active) .lawyer-card {
    box-shadow: none;
  }

  &__slider .embla__viewport {
    padding-right: 108px;
  }

  &__slide {
    flex: 0 0 50%;
    min-width: 0;
    padding-left: 108px;
  }

  &._mobile {
    .container-m();

    padding-left: 0;
    padding-right: 0;
    padding-bottom: 96px;
  }

  &._mobile &__title {
    font-size: @size-x6;
    font-weight: 700;
    line-height: 25px;
    padding: 0 @size-x4;
  }

  &._mobile &__slider .embla__viewport {
    padding-right: 44px;
  }

  &._mobile &__slider .embla__container {
    padding: 48px 0 39px;
  }

  &._mobile &__slide {
    flex: 0 0 100%;
    padding: 0 0 0 44px;
  }

  &._mobile &__slide .footer-profile-link {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
